import React from "react";
import { Link } from "react-router-dom";
import {
  Lock,
  ArrowUpRight,
  Briefcase,
  Code2,
  PenLine,
  Megaphone,
  Mail,
  Lightbulb,
  Brain,
  BarChart3,
  Mic,
  AppWindow,
  Users,
  CalendarCheck,
  TrendingUp,
  Bot,
  Scale,
  Camera,
  Filter,
  GitBranch,
  LayoutTemplate,
  Sparkles as Spark,
} from "lucide-react";

const ICONS = {
  Briefcase,
  Code2,
  PenLine,
  Megaphone,
  Mail,
  Lightbulb,
  Brain,
  BarChart3,
  Mic,
  AppWindow,
  Users,
  CalendarCheck,
  TrendingUp,
  Bot,
  Scale,
  Camera,
  Filter,
  GitBranch,
  LayoutTemplate,
};

export default function ToolCard({ tool, index = 0 }) {
  const isLocked = tool.status === "locked" || !tool.has_access;
  const Icon = ICONS[tool.icon] || Spark;
  const badgeColor =
    tool.access_type === "paid"
      ? "text-amber-400 border-amber-500/30 bg-amber-500/5"
      : tool.access_type === "private"
      ? "text-rose-300 border-rose-500/30 bg-rose-500/5"
      : "text-emerald-300 border-emerald-500/30 bg-emerald-500/5";

  return (
    <div
      data-testid={`tool-card-${tool.id}`}
      className="rise relative overflow-hidden rounded-2xl border border-zinc-800/80 bg-zinc-950/40 card-lift flex flex-col h-full grain"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      {/* Top decorative gradient line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-emerald-500/40 to-transparent" />

      <div className="p-6 flex flex-col gap-5 flex-1 relative z-10">
        <div className="flex items-start justify-between">
          <div className="w-11 h-11 rounded-xl border border-zinc-800 bg-zinc-900/60 flex items-center justify-center">
            <Icon className="w-5 h-5 text-emerald-400" strokeWidth={1.6} />
          </div>
          <div className="flex flex-col items-end gap-1.5">
            <span
              className={`text-[10px] uppercase tracking-[0.18em] px-2 py-0.5 rounded-full border ${badgeColor}`}
            >
              {tool.access_type}
            </span>
            <span className="text-[10px] uppercase tracking-[0.18em] text-zinc-600">
              {tool.category}
            </span>
          </div>
        </div>

        <div>
          <h3 className="font-display text-2xl font-extrabold tracking-tight text-white">
            {tool.name}
          </h3>
          <p className="mt-2 text-sm text-zinc-400 leading-relaxed line-clamp-3">
            {tool.description}
          </p>
        </div>

        <div className="mt-auto flex items-center justify-end pt-4 border-t border-zinc-900">
          {isLocked ? (
            <button
              data-testid={`unlock-btn-${tool.id}`}
              disabled
              className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-rose-500/10 border border-rose-500/40 text-rose-300 text-[12px] font-semibold uppercase tracking-wider cursor-not-allowed"
            >
              <Lock className="w-3 h-3" /> Locked
            </button>
          ) : tool.external_url ? (
            <a
              href={tool.external_url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`open-tool-${tool.id}`}
              className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-emerald-600 text-white text-[12px] font-semibold uppercase tracking-wider hover:bg-emerald-700 transition-colors glow-primary"
            >
              Launch <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
          ) : (
            <Link
              to={`/tools/${tool.id}`}
              data-testid={`open-tool-${tool.id}`}
              className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-emerald-600 text-white text-[12px] font-semibold uppercase tracking-wider hover:bg-emerald-700 transition-colors glow-primary"
            >
              Open <ArrowUpRight className="w-3.5 h-3.5" />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
